<template>
    <div class="btn-group">
        <button type="button" @click="save" :disabled="isProcessing" class="btn btn-primary">
            <i class="bi bi-save"></i> Save
        </button>
        <button type="button"
            v-if="loadedInfo.contest.id !== '' && loadedInfo.contest.id !== '00000000-0000-0000-0000-000000000000'"
            @click="prev" :disabled="isProcessing" class="btn btn-secondary">
            <i class="bi bi-arrow-left"></i> Prev
        </button>
        <button @click="next"
            v-if="loadedInfo.contest.id !== '' && loadedInfo.contest.id !== '00000000-0000-0000-0000-000000000000'"
            type="button" :disabled="isProcessing" class="btn btn-secondary">
            Next <i class="bi bi-arrow-right"></i>
        </button>
    </div>
    <div v-if="!isProcessing" class="row">
        <input type="file" id="fileInput" @change="uploadFile" class="d-none" accept="image/*" />
        <form @submit.prevent="saveContest" id="form-voter-info">
            <div style="text-align: center">
                <div style="text-align: center; position: relative">
                    <div style="position: relative; display: inline-block">
                        <img class="rounded-circle" style="width: 150px; height: 150px; object-fit: cover"
                            id="voter-pic" alt="Profile Picture"
                            :src="loadedInfo.contest.profilePic || 'female-place-holder.jpg'" />

                        <div style="position: absolute; bottom: 0; right: 0">
                            <!-- Add your camera icon here -->
                            <button type="button" id="btn-upload-voter-pic" class="btn btn-secondary">
                                <i class="bi bi-camera" style="font-size: 1.3rem"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-lg-2">
                    <label for="cname">#</label>
                    <input class="form-control" v-model="loadedInfo.contest.numberWinners" />
                </div>
                <div class="form-group col-lg-4">
                    <label for="cname">Name:</label>
                    <input class="form-control" v-model="loadedInfo.contest.name" />
                </div>
                <div class="form-group col-lg-4">
                    <label for="cname">Description:</label>
                    <input class="form-control" v-model="loadedInfo.contest.description" />
                </div>
                <div class="form-group col-lg-2">
                    <label for="slider-toggle" class="form-label">Slider Only:</label>
                    <br />
                    <div class="toggle-container">
                        <input type="checkbox" id="slider-toggle" class="toggle-checkbox" v-model="isSliderComputed" />
                        <label for="slider-toggle" class="toggle-label">
                            <span class="toggle-slider"></span>
                            <span class="ms-5 toggle-text">
                                <span v-if="isSliderComputed" class="toggle-on">ON</span>
                                <span v-else class="toggle-off">OFF</span>
                            </span>
                        </label>
                    </div>
                </div>
            </div>

            <ul class="nav nav-tabs mt-4" id="contestTabs" role="tablist">
                <li class="nav-item" role="presentation">
                    <a :class="['nav-link', { active: activeTab === 'judges' }]" id="judges-tab" data-bs-toggle="tab"
                        href="#judges" role="tab" aria-controls="judges"
                        :aria-selected="(activeTab === 'judges').toString()" @click.prevent="setActiveTab('judges')">
                        Judges
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a :class="['nav-link', { active: activeTab === 'criteria' }]" id="criteria-tab"
                        data-bs-toggle="tab" href="#criteria" role="tab" aria-controls="criteria"
                        :aria-selected="(activeTab === 'criteria').toString()"
                        @click.prevent="setActiveTab('criteria')">
                        Criteria
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a :class="['nav-link', { active: activeTab === 'contestants' }]" id="contestants-tab"
                        data-bs-toggle="tab" href="#contestants" role="tab" aria-controls="contestants"
                        :aria-selected="(activeTab === 'contestants').toString()"
                        @click.prevent="setActiveTab('contestants')">
                        Contestants
                    </a>
                </li>
            </ul>

            <!-- Tab Content Section -->
            <div class="tab-content mt-3" id="contestTabsContent">
                <div class="tab-pane fade" :class="{ 'show active': activeTab === 'judges' }" id="judges"
                    role="tabpanel" aria-labelledby="judges-tab">
                    <div class="card shadow-sm border-0">
                        <div
                            class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                            <h5 class="mb-0">Judges Selection</h5>
                            <button type="button" class="btn btn-secondary btn-sm"
                                @click.stop.prevent="toggleSelectAll">
                                {{ isAllSelected ? 'Uncheck All' : 'Check All' }}
                            </button>
                        </div>
                        <div class="card-body">
                            <div class="list-group">
                                <div class="list-group-item d-flex justify-content-between align-items-center"
                                    v-for="judge in cRefs.judges" :key="judge.id">
                                    <label :for="judge.id" class="mb-0 d-flex align-items-center">
                                        <input type="checkbox" :id="judge.id" :value="judge.id" v-model="selectedJudges"
                                            class="form-check-input me-2" />
                                        {{ `${judge.name} - ${judge.description}` }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Criteria Tab -->
                <div class="tab-pane fade" :class="{ 'show active': activeTab === 'criteria' }" id="criteria"
                    role="tabpanel" aria-labelledby="criteria-tab">
                    <div class="card shadow-sm mb-4">
                        <div class="card-header bg-primary text-white">
                            <h5 class="mb-0">Criteria Information</h5>
                            <div class="text-end">
                                <strong>Total Weight: {{ totalCritsWeight }}</strong>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped align-middle">
                                    <thead>
                                        <tr>
                                            <th>Sequence</th>
                                            <th>Name</th>
                                            <th>Description</th>
                                            <th>Weight</th>
                                            <th>Actions</th>
                                        </tr>
                                        <tr>
                                            <th><input ref="loadedCritRef" type="text" class="form-control"
                                                    v-model="loadedCrit.sequenceNo" /></th>
                                            <th><input type="text" class="form-control" v-model="loadedCrit.name" />
                                            </th>
                                            <th><input type="text" class="form-control"
                                                    v-model="loadedCrit.description" /></th>
                                            <th><input type="text" class="form-control" v-model="loadedCrit.weight" />
                                            </th>
                                            <th>
                                                <div class="btn-group">
                                                    <button type="button" @click="commitCritChanges"
                                                        class="btn btn-sm btn-success">
                                                        <i class="bi bi-save"></i> Save
                                                    </button>
                                                    <button type="button" @click="clearCriteria"
                                                        class="btn btn-sm btn-danger">
                                                        <i class="bi bi-x"></i> Clear
                                                    </button>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="crit in loadedInfo.contest.criterias" :key="crit.id">
                                            <td>
                                                <button type="button" class="btn btn-sm btn-secondary"
                                                    @click.stop.prevent="editCriteria(crit.id)">
                                                    <i class="bi bi-pencil"></i>
                                                </button>
                                                {{ crit.sequenceNo }}
                                            </td>
                                            <td>{{ crit.name }}</td>
                                            <td>{{ crit.description }}</td>
                                            <td>{{ crit.weight }}</td>
                                            <td class="text-end">
                                                <button @click.stop.prevent="removeCriteria(crit.id)" type="button"
                                                    class="btn btn-sm btn-danger">
                                                    <i class="bi bi-trash"></i> Remove
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Contestants Tab -->
                <div class="tab-pane fade" :class="{ 'show active': activeTab === 'contestants' }" id="contestants"
                    role="tabpanel" aria-labelledby="contestants-tab">
                    <div class="card shadow-sm mb-4">
                        <div
                            class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                            <h5 class="mb-0">Contestants Selection</h5>
                            <button type="button" class="btn btn-sm btn-secondary"
                                @click.stop.prevent="toggleSelectAllContestants">
                                {{ isAllContestantsSelected ? 'Uncheck All' : 'Check All' }}
                            </button>
                        </div>
                        <div class="card-body">

                            <div class="form-check" v-for="contestant in cRefs.contestants" :key="contestant.id">
                                <input type="checkbox" :id="contestant.id" :value="contestant.id"
                                    v-model="selectedContestants" class="form-check-input" />
                                <label class="form-check-label" :for="contestant.id"><span
                                        class="fw-bold text-warning">{{ contestant.userPK }} </span> {{ contestant.name
                                        }}</label>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <button type="submit" class="btn btn-primary d-none" id="btnSubmitVoter">
                Save
            </button>
        </form>
    </div>
    <div v-else class="text-center">
        <div class="spinner-border text-danger" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>

<script>
import spinnerService from "@/services/spinnerService";
import { defineComponent, onMounted, ref, watch, computed } from "vue";
import toastService from "@/services/toastService";
import confirmationService from "@/services/confirmationService";
import { hasRoles } from "@/utils/auth";
import eventService from "@/services/eventService";
export default defineComponent({
    props: {
        id: {
            type: String,
            required: true,
            default: () => '',
        },
    },
    emits: ["prev", "next", "reset"],
    setup(props, { emit }) {
        const loadedInfo = ref({
            contest: { isSlider: false, contestJudges: [], criterias: [] },
            groupings: [],
            hhcontent: {},
            logs: [],
        });

        const isSliderComputed = computed({
            get: () => loadedInfo.value.contest.isSlider,
            set: (value) => {
                loadedInfo.value.contest.isSlider = Boolean(value);
            }
        });

        const loadedCritRef = ref(null);
        const leaders = ref([]);
        const subleaders = ref([]);
        const hasAccess = ref(false);
        const households = ref([]);
        const cities = ref([]);
        const sectors = ref([]);
        const currentId = ref(0);
        const currentHHId = ref("");
        const brgys = ref([]);
        const activeTab = ref("judges"); // Default tab
        const selectedCritIndex = ref(-1);
        const cRefs = ref({
            judges: [],
            contestants: []
        });
        const loadedCrit = ref({});
        const pleaders = ref([]);
        const isProcessing = ref(false);
        const selectedContestants = ref([]);
        const selectedJudges = ref([]);
        const isAllSelected = computed(() => selectedJudges.value.length === cRefs.value.judges.length);
        const isAllContestantsSelected = computed(() => selectedContestants.value.length === cRefs.value.contestants.length);
        const totalCritsWeight = computed(() => loadedInfo.value.contest.criterias.reduce((sum, criteria) => sum + Number(criteria.weight || 0), 0));

        const toggleSelectAll = () => {
            if (isAllSelected.value) {
                selectedJudges.value = [];
            } else {
                selectedJudges.value = cRefs.value.judges.map((judge) => judge.id);
            }
        };

        const toggleSelectAllContestants = () => {
            if (isAllContestantsSelected.value) {
                selectedContestants.value = [];
            } else {
                selectedContestants.value = cRefs.value.contestants.map((c) => c.id);
            }
            console.log(JSON.stringify(selectedContestants.value))

        };

        const hasRequiredRole = (requiredRoles) => {
            return hasRoles(requiredRoles);
        };
        const getInfo = async () => {
            if (props.id === '' || props.id === null) return;
            selectedCritIndex.value = -1;
            isProcessing.value = true;
            const resp = await eventService.getInfo(props.id);
            loadedInfo.value.contest = resp.contest;
            cRefs.value = resp.refs;
            preselectJudges();
            preselectContestants();
            isProcessing.value = false;
        };
        const preselectJudges = () => {
            selectedJudges.value = loadedInfo.value.contest.contestJudges.map(
                (contestJudge) => contestJudge.judgeId
            );
        };

        const preselectContestants = () => {
            selectedContestants.value = loadedInfo.value.contest.contestContestants?.map(
                (contestant) => contestant.contestantId
            ) || [];
        };

        onMounted(() => {
            getInfo();
            const savedTab = localStorage.getItem("activeTab");
            if (savedTab) {
                activeTab.value = savedTab;
            }
        });
        const tabChanged = (tab) => {
            switch (tab) {
                case "groupings":
                    break;
                case "households":
                    break;
                default:
                    break;
            }
        };

        const next = () => {
            emit("next");
        };
        const prev = () => {
            emit("prev");
        };
        const save = () => {
            document.getElementById("btnSubmitVoter").click();
        };
        const saveContest = async () => {
            if (!hasRequiredRole(["admin", "candidate-mod"])) {
                toastService.error("You are not allowed to perform this action");
                return;
            }
            if (totalCritsWeight.value !== 100 && loadedInfo.value.contest.criterias.length > 0) {
                toastService.error("Please make sure the total criteria is 100%");
                return;
            }
            const confirmed = await confirmationService.show(
                "Are you sure you want to save changes?"
            );
            if (!confirmed) return;
            try {
                spinnerService.show();
                loadedInfo.value.contest.contestJudges = selectedJudges.value.map((judgeId) => ({
                    id: '00000000-0000-0000-0000-000000000000',
                    judgeId,
                    contestId: loadedInfo.value.contest.id,
                }));
                loadedInfo.value.contest.contestContestants = selectedContestants.value.map(
                    (contestantId) => ({
                        id: '00000000-0000-0000-0000-000000000000',
                        contestantId,
                        contestId: loadedInfo.value.contest.id,
                    })
                );
                const response = await eventService.saveContest(loadedInfo.value.contest);
                if (response.success) {
                    toastService.success(response.message);
                    emit("reset");
                } else {
                    toastService.error(response.message);
                }
            } catch (err) {
                toastService.error("An error occured while processing the request.");
            } finally {
                spinnerService.hide();
            }
        };

        const editCriteria = (id) => {
            const idx = loadedInfo.value.contest.criterias.findIndex(x => x.id === id);
            if (idx > -1) {
                loadedCrit.value = { ...loadedInfo.value.contest.criterias[idx] };
            }
            selectedCritIndex.value = idx;
        }

        const removeCriteria = (id) => {
            const confirmed = confirmationService.show("Are you sure you want to remove this item?");
            if (!confirmed)
                return;
            const idx = loadedInfo.value.contest.criterias.findIndex(x => x.id === id);
            if (idx !== -1) {
                loadedInfo.value.contest.criterias.splice(idx, 1); // Remove the criteria at the found index
            }
            loadedCrit.value = {}; // Reset the loaded criteria object
            selectedCritIndex.value = -1; // Reset the selected index
        };


        const clearCriteria = () => {
            loadedCrit.value = {};
            selectedCritIndex.value = -1;
        }


        const commitCritChanges = () => {
            if (!loadedCrit.value.sequenceNo || isNaN(loadedCrit.value.sequenceNo)) {
                setTimeout(() => {
                    if (loadedCritRef.value) {
                        loadedCritRef.value.focus();
                        loadedCritRef.value.select(); // Optional: select text for easy editing
                    }
                }, 50);
                return; // Stop execution
            }
            if (selectedCritIndex.value === -1) {
                // Add loadedCrit as a new item
                loadedInfo.value.contest.criterias.push(loadedCrit.value);

                // Sort the criterias by sequenceNo
            } else {
                // Update the specific criteria
                loadedInfo.value.contest.criterias[selectedCritIndex.value] = { ...loadedCrit.value };
            }
            loadedCrit.value = {};
            selectedCritIndex.value = -1;
            loadedInfo.value.contest.criterias.sort((a, b) => a.sequenceNo - b.sequenceNo);
        };


        const keywordColors = {
            YOUTH: "orange",
            WOMEN: "pink",
            VENDOR: "darkblue",
            FISHER: "gray",
            FARMER: "green",
            TRICYCLE: "brown",
            DEFAULT: "transparent",
        };

        const keywords = ["youth", "women", "vendor", "fisher", "farmer", "tricycle"];

        const getColorForKeyword = (str) => {
            if (str === null) {
                return keywordColors.DEFAULT; // Default color if null is selected
            }
            for (const keyword of keywords) {
                if (str.toUpperCase().includes(keyword.toUpperCase())) {
                    return keywordColors[keyword.toUpperCase()];
                }
            }
            return keywordColors.DEFAULT; // Default color if no keyword is found
        };

        // Computed property to dynamically return the box style based on the selected keyword
        const boxStyle = computed(() => {
            const color = getColorForKeyword(loadedInfo.value.contest.name);
            return {
                backgroundColor: color,
                padding: "20px",
                borderRadius: "8px",
                color: "#333",
                textAlign: "center",
            };
        });

        const newSector = ref(""); // Holds the new value entered by the user
        const isAdding = ref(false);

        const handleAddNewSector = () => {
            isAdding.value = !isAdding.value;
        };

        const setActiveTab = (tab) => {
            activeTab.value = tab; // Update the active tab
            localStorage.setItem("activeTab", tab); // Save it to localStorage
        };


        const handleCancelAdd = () => {
            isAdding.value = false;
        };


        watch(
            () => props.id,
            () => {
                getInfo();
            }
        );


        return {
            loadedInfo,
            leaders,
            subleaders,
            hasAccess,
            households,
            cities,
            brgys,
            isProcessing,
            tabChanged,
            currentId,
            currentHHId,
            prev,
            next,
            save,
            saveContest,
            hasRequiredRole,
            pleaders,
            sectors,
            newSector,
            handleAddNewSector,
            isAdding,
            handleCancelAdd,
            boxStyle,
            isAllSelected,
            toggleSelectAll,
            selectedJudges,
            cRefs,
            selectedContestants,
            isAllContestantsSelected,
            toggleSelectAllContestants,
            loadedCrit,
            editCriteria,
            commitCritChanges,
            clearCriteria,
            totalCritsWeight,
            removeCriteria,
            activeTab,
            setActiveTab,
            loadedCritRef,
            isSliderComputed
        };
    },
});
</script>

<style scoped>
.toggle-container {
    display: inline-flex;
    align-items: center;
}

.toggle-checkbox {
    display: none;
}

.toggle-label {
    position: relative;
    display: inline-block;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.3);
    border: 2px solid var(--border-gold);
    border-radius: 25px;
    width: 60px;
    height: 30px;
    transition: all 0.3s ease;
}

.toggle-label:hover {
    border-color: var(--gold-primary);
    box-shadow: 0 0 10px var(--shadow-gold);
}

.toggle-slider {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 20px;
    height: 20px;
    background: var(--text-muted);
    border-radius: 50%;
    transition: all 0.3s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}

/* Checked state */
.toggle-checkbox:checked+.toggle-label {
    background: rgba(212, 175, 55, 0.1);
    border-color: var(--gold-primary);
}

.toggle-checkbox:checked+.toggle-label .toggle-slider {
    transform: translateX(30px);
    background: linear-gradient(135deg, var(--gold-primary) 0%, var(--gold-secondary) 100%);
}
</style>